import CorporateLayout from './CorporateLayout';

export default CorporateLayout;
